import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { ReactComponent as DeleteSVG } from '@Assets/Svgs/ic_delete.svg';
import { ReactComponent as SelectionCheckOnSVG } from '@Assets/Svgs/selection_check_on.svg';
import ShowMoreButton from './ShowMoreButton';
import MultipleTextArea from './MultipleTextArea';

const ItemCell = ({
  isUsingEditMode,
  isUsingAchievementChip,
  achievementId,
  title,
  description,
  condition,
  processKeysByAchievementId,
  getIsCurrentLinkedAchievement,
  handleChangeAchievementText,
  handleDuplicateAchievementClick,
  handleDeleteAchievementClick,
  handleSetSelectedAchievementId,
  handleAchievementItemCellClick,
  handleIsNoticeDeleteModalVisible,
}) => {
  const isItemCellVisible = !isUsingAchievementChip || isUsingEditMode || !!title;

  const targetLinkedProcess = processKeysByAchievementId[achievementId];
  const targetLinkedProcessId = targetLinkedProcess && targetLinkedProcess.processId;

  const isReadMode = isUsingAchievementChip ? !isUsingEditMode : false;
  const isShowItemCellButton = isUsingAchievementChip ? !!isUsingEditMode : true;
  const isCurrentLinkedAchievement =
    isUsingAchievementChip && !isUsingEditMode && getIsCurrentLinkedAchievement(achievementId);
  return (
    <ItemCellOuterContainer>
      {isItemCellVisible ? (
        <ItemCellContainer onClick={() => handleAchievementItemCellClick(achievementId)}>
          <MultipleTextArea
            isUsingAchievementChip={isUsingAchievementChip}
            isReadMode={isReadMode}
            targetLinkedProcessId={targetLinkedProcessId}
            achievementId={achievementId}
            title={title}
            description={description}
            condition={condition}
            handleChangeAchievementText={handleChangeAchievementText}
          />

          {isCurrentLinkedAchievement ? (
            <SelectedIconContainer>
              <SelectedIcon />
            </SelectedIconContainer>
          ) : null}

          {isShowItemCellButton ? (
            <ItemCellButtonContainer>
              {title ? (
                <ShowMoreButton
                  achievementId={achievementId}
                  handleDuplicateAchievementClick={handleDuplicateAchievementClick}
                  handleSetSelectedAchievementId={handleSetSelectedAchievementId}
                  handleIsNoticeDeleteModalVisible={handleIsNoticeDeleteModalVisible}
                />
              ) : (
                <DeleteButtonIcon onClick={() => handleDeleteAchievementClick(achievementId)} />
              )}
            </ItemCellButtonContainer>
          ) : null}
        </ItemCellContainer>
      ) : null}
    </ItemCellOuterContainer>
  );
};

ItemCell.propTypes = {
  isUsingEditMode: PropTypes.bool.isRequired,
  isUsingAchievementChip: PropTypes.bool.isRequired,
  achievementId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  condition: PropTypes.string.isRequired,
  processKeysByAchievementId: PropTypes.objectOf(PropTypes.object).isRequired,
  getIsCurrentLinkedAchievement: PropTypes.func.isRequired,
  handleChangeAchievementText: PropTypes.func.isRequired,
  handleDuplicateAchievementClick: PropTypes.func.isRequired,
  handleDeleteAchievementClick: PropTypes.func.isRequired,
  handleSetSelectedAchievementId: PropTypes.func.isRequired,
  handleAchievementItemCellClick: PropTypes.func.isRequired,
  handleIsNoticeDeleteModalVisible: PropTypes.func.isRequired,
};

const ButtonCSS = css`
  width: 32px;
  height: 32px;
`;

const IconCSS = css`
  width: 16px;
  height: 16px;
`;

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
`;

const ItemCellOuterContainer = styled(FlexAlignCenterDiv)`
  width: 100%;
`;

const ItemCellContainer = styled(FlexAlignCenterDiv)`
  width: 100%;

  padding: 13px 14px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.ui_3};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.ui_2};
    background-color: ${({ theme }) => theme.colors.ui_2};
  }
`;

const ItemCellButtonContainer = styled(FlexAlignCenterDiv)`
  ${ButtonCSS}
  justify-content: center;

  position: relative;
  cursor: pointer;
`;

const DeleteButtonIcon = styled(DeleteSVG)`
  ${IconCSS}

  stroke: ${({ theme }) => theme.colors.ui_on_3};
`;

const SelectedIconContainer = styled(FlexAlignCenterDiv)`
  justify-content: center;

  margin-right: 12px;
`;

const SelectedIcon = styled(SelectionCheckOnSVG)`
  ${IconCSS}

  fill: ${({ theme }) => theme.colors.primary}
`;

export default ItemCell;
